<template>
    <TopNav></TopNav>
		<h1>Time Zone Difference Calculator</h1>
		<fieldset>
      <legend>Time Zone Difference Calculator</legend>
			<label for="firstTimeZone">Home Time Zone:</label><br>
      <select name="firstTimeZone" id="firstTimeZone" v-model="firstTimeZone">
        <option value="America/Chicago">America/Chicago</option>
        <option value="America/Denver">America/Denver</option>
        <option value="America/Edmonton">America/Edmonton</option>
        <option value="America/Los_Angeles">America/Los_Angeles</option>
        <option value="America/New_York">America/New_York</option>
        <option value="America/Toronto">America/Toronto</option>
        <option value="America/Vancouver">America/Vancouver</option>
        <option value="America/Winnipeg">America/Winnipeg</option>
        <option value="Asia/Shanghai">Asia/Shanghai</option>
        <option value="Europe/Athens">Europe/Athens</option>
        <option value="Europe/Belgrade">Europe/Belgrade</option>
        <option value="Europe/Berlin">Europe/Berlin</option>
        <option value="Europe/Brussels">Europe/Brussels</option>
        <option value="Europe/Istanbul">Europe/Istanbul</option>
        <option value="Europe/London">Europe/London</option>
        <option value="Europe/Rome">Europe/Rome</option>
        <option value="Europe/Sofia">Europe/Sofia</option>
        <option value="Pacific/Auckland">Pacific/Auckland</option>
        <option value="Pacific/Honolulu">Pacific/Honolulu</option>
      </select>

      <span class="clock">{{ firstTime }}</span>

			<br><br>

      <label for="secondTimeZone">Away Time Zone:</label><br>
      <select name="secondTimeZone" id="secondTimeZone" v-model="secondTimeZone">
        <option value="America/Chicago">America/Chicago</option>
        <option value="America/Denver">America/Denver</option>
        <option value="America/Edmonton">America/Edmonton</option>
        <option value="America/Los_Angeles">America/Los_Angeles</option>
        <option value="America/New_York">America/New_York</option>
        <option value="America/Toronto">America/Toronto</option>
        <option value="America/Vancouver">America/Vancouver</option>
        <option value="America/Winnipeg">America/Winnipeg</option>
        <option value="Asia/Shanghai">Asia/Shanghai</option>
        <option value="Europe/Athens">Europe/Athens</option>
        <option value="Europe/Belgrade">Europe/Belgrade</option>
        <option value="Europe/Berlin">Europe/Berlin</option>
        <option value="Europe/Brussels">Europe/Brussels</option>
        <option value="Europe/Istanbul">Europe/Istanbul</option>
        <option value="Europe/London">Europe/London</option>
        <option value="Europe/Rome">Europe/Rome</option>
        <option value="Europe/Sofia">Europe/Sofia</option>
        <option value="Pacific/Auckland">Pacific/Auckland</option>
        <option value="Pacific/Honolulu">Pacific/Honolulu</option>
      </select>

      <span class="clock">{{ secondTime }}</span>

			<br><br>
      Difference: <span class="result">{{ hoursDiff() }}</span>
		</fieldset>
</template>

<script>
import TopNav from './components/TopNav.vue'
import {DateTime, Duration} from "luxon";

export default {
  name: 'TimeZoneDifference',
  data() {
    return {
      firstTimeZone: "Europe/London",
      secondTimeZone: "America/New_York",
      firstTime: "00:00",
      secondTime: "00:00"
    }
  },
  components: {
    TopNav
  },
  methods: {
    hoursDiff: function () {
      let d1 = DateTime.local().setZone(this.firstTimeZone);
      let d1offset = d1.offset;
      this.firstTime = d1.toFormat("T");

      let d2 = DateTime.local().setZone(this.secondTimeZone);
      let d2offset = d2.offset;
      this.secondTime = d2.toFormat("T");

      let diffMinutes = d1offset - d2offset;

      let absDiffMin = Math.abs(diffMinutes);
      let dur = Duration.fromObject({ minutes: absDiffMin })
      let hours = dur.as('hours');
      if (hours <= 1) {
        return hours + " hour";
      } else {
        return hours + " hours";
      }
    },
    getFirstTimeZoneHour: function () {
      this.firstTime = DateTime.local().setZone(this.firstTimeZone).toFormat("T");
    },
    getSecondTimeZoneHour: function () {
      this.secondTime = DateTime.local().setZone(this.secondTimeZone).toFormat("T");
    }
  },
  mounted: function () {
    setInterval(function () {
      this.getFirstTimeZoneHour();
      this.getSecondTimeZoneHour();
    }.bind(this), 10000)
  }
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}

body {
  margin: 1em auto;
  margin-top: 0;
  max-width: 40em;
  font-family: Arial, Helvetica, sans-serif;
}

.result {
  color: #0063dc;
}

label {
  display: inline-block;
  width: 175px;
}

footer section a {
  margin: 20px;
}

.clock {
  margin-left: 10px;
}
</style>
